<template>
	<el-dialog :visible.sync ="show" :width="width" top="0" @close="close1" :show-close="showClose" :custom-class="wTheme" :close-on-click-modal="false" :close-on-press-escape="false">
		<p slot="title" class="modal-header">
			<i class="el-icon-info"></i>
			<span>{{title}}</span>
		</p>
		<div class="modal-body">
			<slot></slot>
		</div>
		<div slot="footer" class="modal-bottom" v-if="!closeFooter">
			<el-button type="primary" size="small" @click="ok" v-if="hasOnOK">{{okText}}</el-button>
			<el-button size="small" @click="cancel" v-if="hasOnCancel">{{cancelText}}</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import $ from 'jquery';
	import m from 'malihu-custom-scrollbar-plugin';
	import mw from 'jquery-mousewheel';
	import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css';
	export default {
		props: {
			value: {
				required: true,
				default: null
			},
			okText: {
				type: String,
				default: '确认'
			},
			cancelText: {
				type: String,
				default: '取消'
			},
			title: {
				type: String
			},
			width: {
				type: String,
				default: '520px'
			},
			closeFooter: {
				type: Boolean,
				default: false
			},
			showClose: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				show: false,
				modalId: ''
			}
		},
		watch: {
			value(val) {
				this.show = val;
				if(val) {
					this.modalId =  'ws-modal-' + Date.parse(new Date());
					this.init();
				}
			},
			show(val) {
				this.$emit('input', val);
			}
		},
		computed: {
			/**
			 * 系统皮肤
			 * @return {[type]} [description]
			 */
			wTheme() {
				return 'ws-modal ' + this.modalId;
			},
			hasOnOK() {
				return this._events['on-ok'];
			},
			hasOnCancel() {
				return this._events['on-cancel'];
			}
		},
		mounted() {

		},
		methods: {
			//初始化
			init() {
				var obj = this;
				this.$nextTick(function() {
					this.bindScroll();
					$(window).resize(function() {
						obj.bindScroll();
					});
				});
			},
			bindScroll() {
				let pModalId = '.' + this.modalId;
				let windowHeight = $(window).height();
				let modalHeight1 = $(pModalId + ' .el-dialog__body .modal-body').height();
				let modalHeight2 = $(pModalId + ' .el-dialog__body').height();
//				console.log(pModalId + '-----' +modalHeight1 + '---' + modalHeight2);
				let realHeight = modalHeight1 + 100 + 60.71 + 55.8 + 55.98;
				if(realHeight > windowHeight) {
					let r1Height = realHeight - 100;
					let top = 0;
					if(r1Height > windowHeight) {
						//需要出现滚动条
						let r2Height = windowHeight - 60.71 - 55.8 - 33;
						$(pModalId + ' .el-dialog__body').height(r2Height);
						$(pModalId + ' .el-dialog__body').mCustomScrollbar({
							theme: "minimal-dark",
							scrollInertia: 500
						});
					} else {
						top = (windowHeight - r1Height) / 2;
					}
					$(pModalId).css({'top': top + 'px', 'margin-top': '0!important'});
				} else {
					$(pModalId).css({'top': '0px', 'margin-top': '10vh'});
				}
			},
			ok() {
				this.$emit('on-ok');
			},
			cancel() {
				this.$emit('on-cancel');
			},
			close1() {
				console.log('----show-close-------');
			}
		}
	}
</script>

<style>
	.ws-modal{
		border-radius: 0 !important;
	}
	.ws-modal .el-dialog__header {
		background-color: #409EFF;
	}
	.ws-modal .modal-header {
		text-align: center;
		color: #FFFFFF;
	}
	.ws-modal .el-dialog__headerbtn > i{
		color: #FFFFFF!important;
	}
	.ws-modal .el-dialog__headerbtn {
		top: 12px !important;
	}
	.ws-modal .modal-bottom {
		text-align: center;
	}
	.ws-modal .modal-bottom .el-button {
		padding-left: 25px;
		padding-right: 25px;
	}
</style>


// WEBPACK FOOTER //
// index.vue?2957fbf8